export class ChangeAppVisibility {
   public static readonly type = '[App] Change App Visibility';

   constructor(public isVisible: boolean) {}
}
